import "@babel/polyfill";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import "vuetify/dist/vuetify.min.css";
import App from "./App.vue";
import router from "./router";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import VueProgressBar from "vue-progressbar";
import axios from "axios";
import VueAxios from "vue-axios";
import jwt_decode from "jwt-decode";
import VuetifyConfirm from "vuetify-confirm";
import VueFilterDateFormat from "vue-filter-date-format";
import store from "./store";
import {Ripple} from 'vuetify/lib/directives';
import VueI18n from 'vue-i18n'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_TRACKING_ID,
  router
});
Vue.config.productionTip = false;

Vue.prototype.$currentCompany =
  localStorage.getItem("currentCompanyId") === null ||
  localStorage.getItem("currentCompanyName") === null
    ? null
    : {
      id: parseInt(localStorage.getItem("currentCompanyId")),
      name: localStorage.getItem("currentCompanyName")
    };

const options = {
  color: "#fff",//
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.1s",
    opacity: "0.5s",
    termination: 400
  },
  autoRevert: true,
  location: "top",
  inverse: false
};

Vue.use(VueProgressBar, options);
Vue.use(VueAxios, axios);


Vue.use(VueI18n);

const messages = {
  zhHans: {
    $vuetify: {
      "dataIterator": {
        "rowsPerPageText": "每行页数:",
        "rowsPerPageAll": "全部",
        "pageText": "{0}-{1} of {2}",
        "noResultsText": "没有找到结果",
        "nextPage": "下一页",
        "prevPage": "上一页"
      },
      "dataTable": {
        "rowsPerPageText": "每行页数:"
      },
      "noDataText": "暂无数据"
    },
  }
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'zhHans', // set locale
  messages, // set locale messages
});


Vue.use(Vuetify, {
  iconfont: "fa",
  directives: {
    Ripple
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});

Vue.use(VuetifyConfirm, {
  buttonTrueText: "确定",
  buttonFalseText: "取消",
  width: 350,
  property: "$confirm"
});
Vue.use(VueFilterDateFormat);

Vue.mixin({
  computed: {
    currentUser() {
      let accessToken = localStorage.getItem("accessToken");
      if (accessToken == null) {
        return null;
      } else {
        let decoded = jwt_decode(accessToken);
        // console.log(decoded);
        return {username: decoded.sub, role: decoded.role,firmId:decoded.firm,companyId:decoded.company};
      }
    },
    recaptchaSitekey() {
      return '6Lc2_K0UAAAAAPbP53-fOmtGoERoIJA6NCyakpI9';
    },
    rolesItems(){
      let items=[
        {value: "super", text: "超级管理员"},
        {value: "admin", text: "事务所管理员"},
        {value: "branch", text: "事务所分公司管理员"},
        {value: "firm", text: "事务所员工"},
        {value: "user", text: "客户"}
      ];

      if (this.currentUser.role === "super") {
        return items;
      }else if (this.currentUser.role === "admin") {
        items.splice(0, 1);
      } else if (this.currentUser.role === "branch") {
        items.splice(0, 2);
      } else if (this.currentUser.role === "firm") {
        items.splice(0, 3);
      } else if(this.currentUser.role === "user"){
        items.splice(0, 4);
      }else{
        items=[];
      }

      return items;
    },
    hideWhenNotUser(){
      return this.currentUser.role !== "user";
    }
  },
  methods: {
    setCurrentCompany(value) {
      Vue.prototype.$currentCompany = value;
      if (value == null) {
        localStorage.removeItem("currentCompanyId");
        localStorage.removeItem("currentCompanyName");
      } else {
        localStorage.setItem("currentCompanyId", value.id);
        localStorage.setItem("currentCompanyName", value.name);
      }
    },
    saveAs(obj, fileName) {
      if ('msSaveOrOpenBlob' in navigator) {
        // Microsoft Edge and Microsoft Internet Explorer 10-11
        window.navigator.msSaveOrOpenBlob(obj, fileName);
      } else {
        // standard code for Google Chrome, Mozilla Firefox etc
        var tmpa = document.createElement("a");
        tmpa.download = fileName || "download";
        tmpa.href = URL.createObjectURL(obj); //绑定a标签
        tmpa.click(); //模拟点击实现下载
        //延时释放
        setTimeout(function () {
          URL.revokeObjectURL(obj); //用URL.revokeObjectURL()来释放这个object URL
        }, 100);
      }
    }
  }
});

export default new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
